import React, { useState, useEffect, useContext } from 'react';
import AppContext from "../../../Store/AppContext";
import { ObterUrlMidia } from '../../../Services/WhatsApp';

const MensagemImagem = ({ mensagem }) => {
    const { contaWhatsAppDefault } = useContext(AppContext);
    const mediaId = mensagem.logConversasWhatsAppMediaId;
    const initialUrl = mensagem._mediaUrl;

    const [url, setUrl] = useState(initialUrl || null);
    const [loading, setLoading] = useState(!initialUrl);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        if (initialUrl || !mediaId) return;

        setLoading(true);
        ObterUrlMidia(contaWhatsAppDefault, mediaId).then(({ success, url }) => {
            if (success && url) setUrl(url);
            setLoading(false);
        });
    }, [mediaId]);

    if (loading) return <div>[Carregando imagem...]</div>;
    if (!url) return <div>[Imagem não disponível]</div>;

    return (
        <>
            <img
                src={url}
                alt="Imagem WhatsApp"
                className="imagem-whatsapp"
                onClick={() => setModalOpen(true)}
            />

            {modalOpen && (
                <div className="modal-imagem-overlay" onClick={() => setModalOpen(false)}>
                    <img
                        src={url}
                        alt="Imagem em zoom"
                        className="modal-imagem"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <span className="modal-close" onClick={() => setModalOpen(false)}>✕</span>
                </div>
            )}
        </>
    );
};

export default MensagemImagem;
